import { useUser } from './useUser';
import type { EntityVariant } from '../types/common';

/**
 * Retourne le variant de l'entité courante.
 *
 * Source de vérité par ordre de priorité :
 *   1. `user.company.variant` (réponse `/users/me` — vérité backend stable)
 *   2. `sessionStorage.signup_variant` (choix Register avant que la company
 *      ne soit créée — pertinent pendant le flow d'onboarding)
 *   3. Default 'standard'
 *
 * Cette priorité garantit qu'une coopérative existante reste affichée comme
 * telle (sa company.variant prime), tandis qu'un nouveau signup en cours
 * voit déjà le vocabulaire coopératif avant que sa company existe en DB.
 */
export function useCompanyVariant(): EntityVariant {
  const { user } = useUser();

  // 1) Vérité backend
  const backendVariant = (user as any)?.company?.variant;
  if (backendVariant === 'cooperative' || backendVariant === 'standard') {
    return backendVariant;
  }

  // 2) Fallback sessionStorage (flow d'onboarding)
  if (typeof window !== 'undefined') {
    try {
      const stored = sessionStorage.getItem('signup_variant');
      if (stored === 'cooperative' || stored === 'standard') {
        return stored;
      }
    } catch {
      // sessionStorage indisponible (SSR, privacy mode) → ignore
    }
  }

  // 3) Default
  return 'standard';
}
